<template>
  <div class="tab-table">
    <template v-if="activeShippingMethods && activeShippingMethods.length">
      <generic-tab-tile
      v-for="ship in activeShippingMethods"
      :key="ship.item_id"
      :class="{ 'active': ship.item_id === activeItemId }"
      class="tab-tile shipment-tile"
      @click.native="tileSelected(ship, (ship.item_id === activeItemId))">
        <template #first>{{ship.carrier_code}}</template>
        <template #last>
          <div class="wrapp-price">
            <span class="ship-price_final mr-2">{{ shippingAmount && shippingAmount !== ship.amount.value ? shippingAmount : ship.amount.value | price($store) }}</span>
            <span class="ship-price_original" v-show="shippingAmount && shippingAmount !== ship.amount.value">{{ ship.amount.value | price($store) }}</span>
          </div>
        </template>
      </generic-tab-tile>
    </template>
    <template v-else>
      <div class="message">
        {{$t('price-adj.messages.shipments-tab')}}
      </div>
    </template>
  </div>
</template>

<script>
import GenericTabTile from 'theme/components/Checkout/PriceAdjustements/Tabs/Tile/GenericTabTile'

export default {
  name: 'ShipmentTab',
  props: {
    activeItemId: {
      type: String,
      default: () => false
    }
  },
  computed: {
    activeShippingMethods () {
      return this.$store.getters['checkout/getActiveShippingMethods']
    },
    shippingAmount () {
      return this.$store.getters['cart/getShippingAmount']
    }
  },
  methods: {
    tileSelected (ship, isActive) {
      // use isActive as toggle eventEmit
      ship['final_price'] = this.shippingAmount !== ship.amount.value ? this.shippingAmount : ship.amount.value
      let selection = isActive ? '' : ship
      return this.$emit('tile-selected', selection)
    }
  },
  components: {
    GenericTabTile
  }
}
</script>
